import * as TK from 'components/post/GivingLinkButton/translations/constants';
import { Translations } from 'translations/types';

export const givingLinkButtonEnUsLocale: Translations = {
  [TK.GIVING_LINK_BUTTON_LABEL]: 'Give',
};
